import { DefaultMetric } from './DefaultMetric';

export class DefaultMetricGroup {
  uuid: string;
  name: string;
  priority = 1;
  defaultMetrics: DefaultMetric[] = [];
}

export class MetricGroupDuplicate {
  metricGroupName: string;
  orgName: string;
  metricNames: string[];
}
